import {packagedeals} from "./feature.packagedeals.svelte";
import {booking} from "../booking/feature.booking.svelte.js";
import * as packagedeals_select from './packagedeals.scenarios.select.svelte.js';
import * as products_select from "../products/products.scenarios.select.svelte.js";

export function getPackageDealByID(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);
  const aPackageDeals = packagedeals.lItems;
  const oFoundPackageDeal = aPackageDeals.find(oPackageDeal => oPackageDeal.iID === iPackageDealID);
  //window.console.log("!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*!*! getPackageDealByID ", iPackageDealID, $state.snapshot(oFoundPackageDeal));

  return oFoundPackageDeal || false;
}

export function getAllAvailablePackageDeals()
{
  return packagedeals.lAvailablePackageDeals;
}

export function isPackageDealStillAvailableWithCurrentBookingSettings(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);
  const iArrivalTime = booking.iArrivalTime; // Assuming `booking` is a shared store or import
  const oPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);
  if ( !oPackageDeal ) return false;

  const oBookedPackageDealInfoForDate = packagedeals_select.getPackageDealInfoForLastProcessedDate(iPackageDealID);
  if ( !oBookedPackageDealInfoForDate ) return false;

  const bContainsTreatments = oPackageDeal.bContainsTreatments;

  if ( bContainsTreatments === true && iArrivalTime >= 1600 )
  {
    return false;
  }

  return true;
}

export function getAvailablePackageDealsForCurrentBooking()
{
  const aAvailablePackageDeals = packagedeals.lAvailablePackageDeals;

  const aRelevantPackageDeals = aAvailablePackageDeals.filter(mAvailablePackageDeal => {
    const oPackageDeal = packagedeals_select.getPackageDealByID(mAvailablePackageDeal.iID);
    return oPackageDeal && packagedeals_select.isPackageDealStillAvailableWithCurrentBookingSettings(mAvailablePackageDeal.iID);
  });

  return aRelevantPackageDeals;
}

export function getPackageDealInfoForLastProcessedDate(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);

  const aAvailablePackageDealCategories = packagedeals.lAvailablePackageDeals;
  for ( const oAvailablePackageDealCategory of aAvailablePackageDealCategories )
  {
    const aItems = oAvailablePackageDealCategory.lItems;

    if ( aItems )
    {
      for ( const oAvailablePackageDeal of aItems )
      {
        if ( oAvailablePackageDeal.iID === iPackageDealID )
        {
          return oAvailablePackageDeal;
        }
      }
    }
  }

  return false;
}

export function getPackageDealCatIDForLastProcessedDate(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);
  const aAvailablePackageDealCategories = packagedeals.lAvailablePackageDeals;

  for ( const oAvailablePackageDealCategory of aAvailablePackageDealCategories )
  {
    const aItems = oAvailablePackageDealCategory.lItems;

    if ( aItems )
    {
      for ( const oAvailablePackageDeal of aItems )
      {
        if ( parseInt(oAvailablePackageDeal.iID) === iPackageDealID )
        {
          return oAvailablePackageDealCategory.iID;
        }
      }
    }
  }

  return false;
}

export function getProductInPackageDeal(iPackageDealID, iProductID)
{
  iPackageDealID = parseInt(iPackageDealID);
  const aPackageDeals = packagedeals.lItems;
  const oRelevantPackageDeal = aPackageDeals.find(mPackageDeal => mPackageDeal.iID === iPackageDealID);
  if ( !oRelevantPackageDeal ) return false;

  const aProductsInPackageDeal = oRelevantPackageDeal.lProducts;
  const oRelevantProduct = aProductsInPackageDeal.find(mProductInPackageDeal => mProductInPackageDeal.iID === iProductID);

  return oRelevantProduct || false;
}

export function getProductsThatAreIncludedInPackageDeal(iPackageDealID)
{
  iPackageDealID = parseInt(iPackageDealID);
  const oPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);

  if ( !oPackageDeal ) return [];

  const aProducts = oPackageDeal.lProducts;
  if ( !aProducts ) return false;

  const aResponse = [];

  for ( const oProduct of aProducts )
  {
    const iChoiceID = oProduct.iChoiceID;

    if ( iChoiceID !== undefined )
    {
      if ( iChoiceID === 0 || iChoiceID === "0" || iChoiceID === false )
      {
        //const sKey = `set${iChoiceID}`;
        //if ( !aProducts[sKey] ) aProducts[sKey] = [];
        //aProducts[sKey] = oProduct;
        let oResponseForProduct = $state.snapshot({...oProduct});
        oResponseForProduct.oProduct = products_select.getProductByID(oResponseForProduct.iID);
        aResponse.push(oResponseForProduct);
        //window.console.log('Het product in de arr is:', oResponseForProduct);
      }
    }
  }

  // window.console.log('floeper getProductsThatAreIncludedInPackageDeal getProductsThatAreIncludedInPackageDeal getProductsThatAreIncludedInPackageDeal getProductsThatAreIncludedInPackageDeal', iPackageDealID, aResponse);
  return aResponse;
}

export function getProductGroupsThatAreOptionInPackageDeal(iPackageDealID)
{
  //window.console.log('getProductGroupsThatAreOptionInPackageDeal a', iPackageDealID);
  iPackageDealID = parseInt(iPackageDealID);
  const oPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);
  if ( !oPackageDeal ) return [];

  const aProducts = oPackageDeal.lProducts;
  if ( !aProducts ) return false;

  const aProductGroups = [];
  const oProducts = {};

  let iHighestChoiceID = 0;

  //window.console.log('getProductGroupsThatAreOptionInPackageDeal b', $state.snapshot(aProducts));

  for ( const oProduct of aProducts )
  {
    const iChoiceID = oProduct.iChoiceID;

    if ( iChoiceID !== undefined && iChoiceID !== false )
    {
      if ( iChoiceID > iHighestChoiceID ) iHighestChoiceID = iChoiceID;
      const sKey = `set${iChoiceID}`;
      //console.log('floeper 1', sKey);
      if ( !oProducts[sKey] ) oProducts[sKey] = [];
      oProducts[sKey].push(oProduct);
    }
  }

  for ( let i = 1; i <= iHighestChoiceID; ++i )
  {
    const sKey = `set${i}`;
    if ( oProducts[sKey] )
    {
      aProductGroups.push({
        iChoiceID: i,
        aBuyables: oProducts[sKey]
      });
    }
  }

  //window.console.log('getProductGroupsThatAreOptionInPackageDeal c', aProductGroups);
  return aProductGroups;
}

export function isPackageDealAvailableForAllPeople(iPackageDealID)
{
  return packagedeals_select.isPackageDealAvailableForNrOfPeople(iPackageDealID, booking.lPeople.length);
}

export function isPackageDealAvailableForNrOfPeople(iPackageDealID, iNrOfPeople)
{
  return true; //

  // // controleer de beschikbaarheid van producten
  // // producten in keuzegroep 0 die niet optioneel zijn moeten allemaal iNrOfPeople vrije tijdslots hebben
  // // producten die in een keuzegroep >  0 zitten, daarvan moet er iig 1 per keuze iNrOfPeople vrije tijdslots hebben
  // //  aangezien we vooralsnog in elke tijdsdropdown ook de optie 'plan maar ergens in' bij komt
  //
  // // NB de gedachte is nog altijd dat er over al die producten in een arrangement max maar 1 is met tijdslots dus denk niet te ingewikkeld
  //
  // //const oPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);
  // const aProductsIncludedInPackageDeal = packagedeals_select.getProductsThatAreIncludedInPackageDeal(iPackageDealID);
  // const aProductGroupsThatAreOptionInPackageDeal = packagedeals_select.getProductGroupsThatAreOptionInPackageDeal(iPackageDealID);
  // let iProductID;
  //
  // // ChoiceID = 0 producten
  // aProductsIncludedInPackageDeal.forEach((oProductInBookedPackageDeal) => {
  //   iProductID = oProductInBookedPackageDeal.iID;
  //   if ( products_select.areThereSlotsForThisNrOfPeople(iProductID, iNrOfPeople) !== true )
  //   {
  //     return false;
  //   }
  // });
  //
  // // ChoiceID > 0 producten
  // let iChoiceID, aProducts;
  //
  // aProductGroupsThatAreOptionInPackageDeal.forEach((oProductGroupInBookedPackageDeal) => {
  //   iChoiceID = oProductGroupInBookedPackageDeal.iChoiceID;
  //   aProducts = oProductGroupInBookedPackageDeal.aBuyables;
  //
  //   aProducts.forEach((oProduct) => {
  //     if ( products_select.areThereSlotsForThisNrOfPeople(oProduct.iID, iNrOfPeople) !== true )
  //     {
  //       return false;
  //     }
  //   });
  // });
  //
  // return true;
}